import React from 'react';
import { useSelector } from 'react-redux';
import { selectFormsWithUnsavedChanges } from '../../cartState/selectors';
import { useBeforeunload } from 'react-beforeunload';

const UnsavedChangesWarning = () => {
  const unsavedChanges = useSelector(selectFormsWithUnsavedChanges);

  useBeforeunload((e) => {
    if (unsavedChanges.length) {
      e.preventDefault();
    }
  });

  return null;
};

export default UnsavedChangesWarning;
